import { AfterViewInit, ChangeDetectionStrategy, Component, inject, Input } from "@angular/core";
import { toolbarOptions } from "../../../shared/model/toolbar-constants";
import { ToolbarService } from "../../services/internal-services/toolbar.service";
import { IPopup } from "../../interfaces/i-popup";
import { IFootprintVisibility } from "../../interfaces/i-footprint-visibility";

import {
  GoogleAnalyticsConstantsCategory,
  GoogleAnalyticsConstantsEvents,
} from "../../../shared/model/google-analytics-constants";
import { DualCommunicatorService } from "../../services/internal-services/dual-communicator.service";
import { FeatureFlagsService } from "../../services/internal-services/feature-flags.service";
import { FeatureFlags } from "../../model/feature-flags";
import { GoogleAnalyticsService } from "../../../shared/services/google-analytics.service";
import { VIEWER_SERVICE } from "../../services/internal-services/viewer-services/inject-base-viewer.service";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-properties-locations-manager",
  templateUrl: "./properties-locations-manager.component.html",
  styleUrls: ["./properties-locations-manager.component.scss"],
  standalone: false,
})
export class PropertiesLocationsManagerComponent implements AfterViewInit {
  viewerService = inject(VIEWER_SERVICE);

  toolbarOption = toolbarOptions.INFO_PROPERTIES_MANAGER;

  displayPanel = false;

  dualViewLoaded = false;

  private _infoProperties: IPopup[];

  private _enabledProperties: boolean = false;

  private _enabledPropertiesReport: boolean = false;

  private _disabled = true;

  defaultVisibilityValues: IFootprintVisibility = {
    propertyFootprint: true,
    labelsFootprint: true,
  };

  get disabled(): boolean {
    return this._disabled;
  }

  @Input() set disabled(value: boolean) {
    this._disabled = value;
  }

  @Input() set infoProperties(value: IPopup[]) {
    if (!this.dualViewLoaded) {
      this._infoProperties = value;
      if (this._infoProperties?.length) {
        this.toolbarService.enableTool(this.toolbarOption);
      } else {
        this.displayPanel = false;
        this.toolbarService.enableTool(toolbarOptions.NONE);
      }
    } else {
      this.dualViewLoaded = false;
    }
  }

  get infoProperties(): IPopup[] {
    return this._infoProperties;
  }

  @Input() set enabledProperties(value: boolean) {
    this._enabledProperties = value;
  }

  @Input() set enabledPropertiesReport(value: boolean) {
    this._enabledPropertiesReport = value;
  }

  @Input() set enabledTool(tool: string) {
    this.displayPanel = this.toolbarOption === tool;
  }

  get enabledProperties(): boolean {
    return this._enabledProperties;
  }

  get enabledPropertiesReport(): boolean {
    return this._enabledPropertiesReport;
  }

  constructor(
    public dualCommunicatorService: DualCommunicatorService,
    protected googleAnalyticsService: GoogleAnalyticsService,
    protected toolbarService: ToolbarService,
    protected flagService: FeatureFlagsService,
  ) {}

  FeatureFlags = FeatureFlags;

  ngAfterViewInit() {
    if (
      this.dualCommunicatorService.startInfoProperties &&
      this.dualCommunicatorService.startInfoProperties.length > 0
    ) {
      this._infoProperties = JSON.parse(JSON.stringify(this.dualCommunicatorService.startInfoProperties));
      this.dualViewLoaded = true;
      this.viewerService.setInfoProperties(this._infoProperties);
    }
  }

  togglePanelDisplay() {
    this.toolbarService.enableTool(!this.displayPanel ? this.toolbarOption : toolbarOptions.NONE);
    this.googleAnalyticsService.setGoogleAnalyticsEvent(
      GoogleAnalyticsConstantsEvents.SHOW_INFO_CARD,
      GoogleAnalyticsConstantsCategory.LEFT_TOOLBAR,
      this.displayPanel,
    );
  }

  updateDefaultVisibilityValues(value: IFootprintVisibility) {
    this.defaultVisibilityValues = { ...value };
  }
}
